module.exports = __webpack_public_path__ + "img/question-octagon-fill.86174f97.svg";